export default "__VITE_ASSET__9965587b__"